import { MdRecommend } from "react-icons/md";

export default function MenuItem({ name, price, isrecommend }: { name: string, price: number, isrecommend?: boolean }) {
    function formatNumber(n: number) {
        if (n >= 1000) {
            return (n / 1000).toFixed(0) + ' K';
        } else {
            return n.toString();
        }
    }
    return (
        <div className="flex flex-row justify-between relative">
            {
                isrecommend && <div className='absolute -left-4 top-1' ><MdRecommend /></div>
            }
            <p className="w-3/4 ml-2 nameitem whitespace-nowrap overflow-hidden font-cursive2 tracking-wider">{name}</p>
            <p className="w-1/4 font-cursive2 tracking-wider">Rp. {formatNumber(price)}</p>
        </div>
    )
}